export const FAQ_ITEMS = [
  {
    id: 1,
    pergunta: 'Como faço para entrar no Lily Book Club?',
    resposta:
      'É simples! Basta acessar nosso site, escolher a turma desejada e selecionar o ingresso ideal para você:\n\n• Lily Pass: para quem está participando pela primeira vez ou já participou de até 3 edições.\n• Lily Member: para participantes que já estiveram conosco em 4 ou mais edições.\n• Ingresso Social: destinado a mulheres cis ou trans em situação de vulnerabilidade social.\n\nApós concluir sua inscrição, é só aguardar nosso encontro!',
  },
  {
    id: 2,
    pergunta: 'Como é escolhido o livro do mês?',
    resposta:
      'A escolha acontece de forma colaborativa. No início de cada mês, realizamos uma enquete exclusiva em nossa comunidade no WhatsApp, onde as participantes votam e decidem qual será a próxima leitura.',
  },
  {
    id: 3,
    pergunta: 'Quando as inscrições abrem?',
    resposta:
      'As inscrições acontecem no início de cada mês e são realizadas exclusivamente pelo nosso site.',
  },
  {
    id: 4,
    pergunta: 'Quando acontecem os encontros?',
    resposta:
      'Os encontros acontecem uma vez por mês, em dois horários diferentes, para que você possa escolher o que melhor se encaixa na sua rotina.',
  },
  {
    id: 5,
    pergunta: 'Quanto custa participar?',
    resposta:
      'O valor do ingresso pode variar de acordo com o plano escolhido e a edição vigente. Todos os valores atualizados estão disponíveis em nosso site no período de inscrições.',
  },
  {
    id: 6,
    pergunta: 'Como fico sabendo de todas as informações?',
    resposta:
      'Todas as novidades, avisos e informações importantes são compartilhadas em nossa comunidade gratuita no WhatsApp. É por lá que você acompanha tudo sobre as próximas edições.',
  },
  {
    id: 7,
    pergunta: 'Preciso comprar o livro físico?',
    resposta:
      'Não. Em nossa comunidade disponibilizamos o PDF ou o arquivo ePub (ideal para Kindle e outros leitores digitais), para que todas possam acompanhar a leitura. Se preferir ter o livro físico, você pode adquiri-lo por conta própria.',
  },
  {
    id: 8,
    pergunta: 'Preciso pagar para entrar na comunidade?',
    resposta:
      'Não! Nossa comunidade no WhatsApp é 100% gratuita. O pagamento é necessário apenas para participar dos encontros presenciais e viver toda a experiência do clube.',
  },
  {
    id: 9,
    pergunta: 'O que está incluso no ingresso?',
    resposta:
      'Seu ingresso inclui toda a experiência do Lily Book Club:\n\n• Mimos exclusivos\n• Comidinhas e bebidas\n• Dinâmicas e atividades especiais\n• Decoração temática\n• Um encontro pensado para gerar conexões, conversas e experiências inesquecíveis.',
  },
  {
    id: 10,
    pergunta: 'Posso ir sozinha?',
    resposta:
      'Com certeza! Muitas participantes chegam sozinhas ao primeiro encontro. O Lily Book Club foi criado justamente para conectar mulheres apaixonadas por livros, então você será muito bem recebida e terá a oportunidade de fazer novas amizades.',
  },
  {
    id: 11,
    pergunta: 'Onde acontecem os encontros?',
    resposta:
      'Os encontros acontecem presencialmente em Manaus. O local e todas as orientações da edição são enviados às participantes após a inscrição e também divulgados em nossa comunidade no WhatsApp.',
  },
];
